/**
 * @file Discover album folder start for the Schools vertical.
 */

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import OnboardingLandingSchools from '../../onboarding/start/OnboardingLandingSchools';
import { allowsFreeJoin } from '../../../util/discover-album-folder';
import getConfig from '../../../util/config';
import LogoPoweredBy from '../../global/LogoPoweredBy';

const propTypes = {
  albumFolder: PropTypes.shape({
    name: PropTypes.string,
    account: PropTypes.shape({
      name: PropTypes.string,
      organization_name: PropTypes.string,
    }),
  }).isRequired,
  onGetStarted: PropTypes.func.isRequired,
};

const DiscoverAlbumFolderStartSchools = ({ albumFolder, onGetStarted }) => {
  const config = getConfig();

  return (
    <Fragment>
      <OnboardingLandingSchools
        albumFolder={albumFolder}
        onGetStarted={onGetStarted}
        isFreeJoin={allowsFreeJoin(albumFolder)}
      />
      <a
        href={config.marcomUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="discovery-start-logo"
      >
        <LogoPoweredBy />
      </a>
    </Fragment>
  );
};

DiscoverAlbumFolderStartSchools.propTypes = propTypes;

export default DiscoverAlbumFolderStartSchools;
